export const PROPERTY_GRID_CONSTANTS = {
  OTHER_GROUP_NAME: 'Other',
};
